import React from "react";
import { Link, useNavigate } from "react-router-dom";
import BabylonLogo from "../../assets/babylon1.png";
import { scrollToTop } from "../../utils/navigation";

const Header = () => {
  const navigate = useNavigate();
  return (
    <div className="sticky top-0 z-50 flex items-center justify-between px-20 py-2 shadow-sm bg-customSlate-500 shadow-black/50">
      <div className="flex items-center gap-5">
        <img
          src={BabylonLogo}
          alt="babylon"
          width={120}
          onClick={(e) => {
            navigate("/");
            window.scrollTo(0, 0);
          }}
          className="cursor-pointer"
        />
        <span
          className="font-bold cursor-pointer text-customText-900"
          onClick={(e) => {
            navigate("/");
            window.scrollTo(0, 0);
          }}>
          ELECTRIC COOPERATIVE
        </span>
      </div>
      <div className="space-x-4">
        <Link to="/signin">
          <button className="px-4 py-1 text-sm font-semibold rounded-md cursor-pointer ring-2 ring-customSlate-700 text-customText-900 hover:bg-customSlate-600 hover:ring-customSlate-600">
            Login
          </button>
        </Link>
        <Link to="/signup">
          <button className="px-4 py-1 text-sm font-semibold rounded-md cursor-pointer ring-2 ring-customGreen-500 text-customText-100 bg-customGreen-500 hover:ring-customGreen-700 hover:bg-customGreen-700">
            Sign Up
          </button>
        </Link>
      </div>
    </div>
  );
};

export default Header;
